/**
 * Обновляет поле строки ремонта с учетом связи с каталогом.
 * При ручной смене типа старая catalog_item_id становится невалидной,
 * потому что один catalog item относится к конкретному типу позиции.
 * @param {Object} item - Строка ремонта
 * @param {string} field - Имя изменяемого поля
 * @param {*} value - Новое значение поля
 * @returns {Object}
 */
export const updateRepairItemField = (item, field, value) => {
  if (!item) return item;

  const oldValue = item[field];
  item[field] = value;

  if (
    field === "item_type" &&
    oldValue !== value &&
    item.catalog_item_id
  ) {
    item.catalog_item_id = null;
    item.create_catalog_item =
      String(item.name || "").trim().length > 0;
  }

  return item;
};

/**
 * Проверяет заполненность поля строки ремонта для визуального состояния label.
 * @param {Object} item - Строка ремонта
 * @param {string} field - Имя проверяемого поля
 * @returns {boolean}
 */
export const repairItemFieldIsFilled = (item, field) => {
  if (!item) return false;

  const value = item[field];
  return (
    value !== null &&
    value !== undefined &&
    String(value).trim() !== ""
  );
};
